import { render, staticRenderFns } from "./poi-detail.vue?vue&type=template&id=3e98a724&scoped=true&"
import script from "./poi-detail.vue?vue&type=script&lang=ts&"
export * from "./poi-detail.vue?vue&type=script&lang=ts&"
import style0 from "./poi-detail.vue?vue&type=style&index=0&id=3e98a724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e98a724",
  null
  
)

export default component.exports